export const sanitizeUrl = (url: string): string => {
    if (url.startsWith('http://')) {
        return url.replaceAll(/^http:\/\//g, 'https://');
    }
    return url;
};

export type SanitizeSegmentUrlOptions = {
    fallback?: string;
    includeSearch?: boolean;
};

function normalizePathname(pathname: string): string {
    return pathname.replaceAll(/\/+/g, '/').replaceAll(/\/$/g, '') || '/';
}

export function sanitizeSegmentUrl(url: string, base: string, options: SanitizeSegmentUrlOptions = {}): string {
    const { fallback = '/', includeSearch = false } = options;

    if (url.length > 255) return fallback;
    if (url.startsWith('//')) return fallback;

    try {
        const parsed = new URL(url, base);
        const normalizedPath = normalizePathname(parsed.pathname);

        return includeSearch ? `${normalizedPath}${parsed.search}` : normalizedPath;
    } catch {
        return fallback;
    }
}
